// FAQ accordion toggle
(() => {
  const root = document;

  const toggleItem = (item) => {
    if (!item) return;
    const btn = item.querySelector(".faq_q");
    const panel = item.querySelector(".faq_a");
    if (!btn || !panel) return;

    const isOpen = item.classList.toggle("is-open");
    btn.setAttribute("aria-expanded", String(isOpen));
    panel.setAttribute("aria-hidden", String(!isOpen));
  };

  root.addEventListener("click", (e) => {
    const target = e.target;
    if (!(target instanceof Element)) return;
    const btn = target.closest(".faq_q");
    if (!btn) return;
    const item = btn.closest(".faq_item");
    toggleItem(item);
  });
})();
